/**
 * Game Context Definition
 * Separated for React Fast Refresh compatibility
 */

import { createContext } from 'react'
import type { InteractiveGameState, SkillCategory } from '../types'

export interface GameContextType {
  state: InteractiveGameState
  click: (resource: SkillCategory) => void
  unlockSkill: (skillId: string) => { success: boolean; message: string }
  canAfford: (skillId: string) => boolean
  hasPrerequisites: (skillId: string) => boolean
  getPassiveIncome: () => InteractiveGameState['resources']
  resetGame: () => void
  saveGame: () => void
  isGameActive: boolean
  startGame: () => void
}

export const GameContext = createContext<GameContextType | null>(null)
